import React, { FunctionComponent } from 'react';
import { faFileCode } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconEmailTemplate: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faFileCode} />;

export { BrassIconEmailTemplate };
